export const BASE_URL = 'https://pypirecom-api.azurewebsites.net';

// For local testing set 
// export const BASE_URL = 'http://127.0.0.1:8000'